import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { expand } from 'rxjs';
import { AuthService } from '../demo/service/auth.service';
import { ROLES } from '../demo/constants/roles.constant';
import { EventService } from '../demo/service/event.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
  isAccept: boolean = false;
  model: any[] = [];
  role: any;
  constructor(public layoutService: LayoutService,
    private authService: AuthService,
    private eventService: EventService,
  ) { }

  ngOnInit() {
    this.initailizeIsAccept();
    this.role = this.authService.getRoleId()
    let allMenus = [
      {
        items: [
          { label: 'หน้าแรก', icon: 'pi pi-fw pi-home', routerLink: ['/info'] }
        ]
      },
      {
        items: [
          { label: 'คู่มือการใช้งาน', icon: 'pi pi-fw pi-book', routerLink: ['/wastemanual'] }
        ]
      },
      {
        items: [
          { label: 'แจ้งเข้ารับกากของเสีย', icon: 'pi pi-fw pi-truck', routerLink: ['/wasteshipment'] }
        ]
      },
      {
        items: [
          { label: 'ติดตามสถานะ', icon: 'pi pi-fw pi-map-marker', routerLink: ['/trackshipment'] }
        ]
      },
      {
        items: [
          {
            label: 'ปริมาณที่ได้รับอนุญาตกำจัด', iconPath: 'assets/layout/images/icon/icon-leaf.svg', routerLink: ['/wastepermit']
          }
        ]
      },
      {
        items: [
          { label: 'Waste label', icon: 'pi pi-fw pi-print', routerLink: ['/wastelabel'] }
        ]
      },
      {
        items: [
          {
            label: 'รายงาน', icon: 'pi pi-fw pi-file',
            items: [
              { label: 'Offsite waste report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/offsitewastereport'] },
              { label: 'Monthly report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/monthlyreport'] },
              { label: 'EIA report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/eiareport'] },
              { label: 'GEI report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/geireport'] },
              { label: 'Waste transportation (CFO)', icon: 'pi pi-fw pi-circle', routerLink: ['/report/transportationreport'] },
              { label: 'IEAT report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/ieatreport'] },
              { label: 'Sale report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/salereport'] },
            ]
          },
        ]
      },
      {

        items: [
          {
            label: 'การจัดการข้อมูล', icon: 'pi pi-fw pi-database',
            items: [
              { label: 'ทะเบียนกากของเสีย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/wastemastermanage'] },
              { label: 'ทะเบียนโรงงาน', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/manageplant'] },
              { label: 'ทะเบียนผู้รับกำจัด', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/disposermanage'] },
              { label: 'รหัสวิธีการกำจัด', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/managedisposalmethod'] },
              { label: 'ประเภทของเสีย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/managewasteinfo'] },
              { label: 'ประเภทรถ', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/managetrucktype'] },
              { label: 'รายการของเสียที่ขาย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/unitpricemanage'] },
              { label: 'แบนเนอร์', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/managebanner'] },
              { label: 'Announcement', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/manageannouncement'] },
              { label: 'คู่มือผู้ใช้งาน', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/managemanual'] },
              { label: 'บัญชีผู้ใช้งาน', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/manageaccount'] },
            ]
          },
        ]
      },
    ];

    switch (this.role) {
      case ROLES.DISPOSER:
        let labelsToRemoveForDisposer = ['รายงาน', 'Waste label', 'ปริมาณที่ได้รับอนุญาตกำจัด'];

        allMenus = allMenus.filter(menu => !labelsToRemoveForDisposer.includes(menu.items[0].label));

        allMenus.forEach(menuSection => {
          console.log('sese',menuSection);
          if (menuSection.items.some(item => item.label === 'การจัดการข้อมูล')) {
            menuSection.items.forEach(item => {
              if (item.label === 'การจัดการข้อมูล') {
                item.items = [
                  { label: 'ทะเบียนผู้รับกำจัด', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/disposermanage'] }
                ];
              }
            });
          }
        });
        break;

      case ROLES.WASTECO:
        let labelsToRemoveForWasteCo = ['แจ้งเข้ารับกากของเสีย'];

        allMenus = allMenus.filter(menu => !labelsToRemoveForWasteCo.includes(menu.items[0].label));

        allMenus.forEach(menuSection => {
          if (menuSection.items.some(item => item.label === 'การจัดการข้อมูล')) {
            menuSection.items.forEach(item => {
              if (item.label === 'การจัดการข้อมูล') {
                item.items = [
                  { label: 'ทะเบียนกากของเสีย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/wastemastermanage'] },
                  { label: 'ทะเบียนผู้รับกำจัด', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/disposermanage'] }
                ];
              }
            });
          }

          if (menuSection.items.some(item => item.label === 'รายงาน')) {
            menuSection.items.forEach(item => {
              if (item.label === 'รายงาน') {
                item.items = [
                  { label: 'Offsite waste report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/offsitewastereport'] },
                ];
              }
            });
          }
        });
        break;

      case ROLES.REGADMIN:
        let labelsToRemoveForRegAdmin = ['แจ้งเข้ารับกากของเสีย', 'Waste label'];

        allMenus = allMenus.filter(menu => !labelsToRemoveForRegAdmin.includes(menu.items[0].label));

        allMenus.forEach(menuSection => {
          if (menuSection.items.some(item => item.label === 'การจัดการข้อมูล')) {
            menuSection.items.forEach(item => {
              if (item.label === 'การจัดการข้อมูล') {
                item.items = [
                  { label: 'ทะเบียนกากของเสีย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/wastemastermanage'] },
                  { label: 'ทะเบียนโรงงาน', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/manageplant'] },
                  { label: 'ทะเบียนผู้รับกำจัด', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/disposermanage'] },
                  { label: 'รหัสวิธีการกำจัด', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/managedisposalmethod'] },
                  { label: 'ประเภทของเสีย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/managewasteinfo'] }
                ];
              }
            });
          }

          if (menuSection.items.some(item => item.label === 'รายงาน')) {
            menuSection.items.forEach(item => {
              if (item.label === 'รายงาน') {
                item.items = [
                  { label: 'Offsite waste report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/offsitewastereport'] },
                  { label: 'EIA report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/eiareport'] },
                  { label: 'IEAT report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/ieatreport'] },
                ];
              }
            });
          }
        });
        break;

        case ROLES.ACCOUNT:
        case ROLES.PURCHASING:
        let labelsToRemoveForAccount = ['แจ้งเข้ารับกากของเสีย', 'Waste label', 'ปริมาณที่ได้รับอนุญาตกำจัด'];

        allMenus = allMenus.filter(menu => !labelsToRemoveForAccount.includes(menu.items[0].label));

        allMenus.forEach(menuSection => {
          if (menuSection.items.some(item => item.label === 'การจัดการข้อมูล')) {
            menuSection.items.forEach(item => {
              if (item.label === 'การจัดการข้อมูล') {
                item.items = [
                  { label: 'รายการของเสียที่ขาย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/unitpricemanage'] },
                ];
              }
            });
          }

          if (menuSection.items.some(item => item.label === 'รายงาน')) {
            menuSection.items.forEach(item => {
              if (item.label === 'รายงาน') {
                item.items = [
                  { label: 'Sale report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/salereport'] },
                ];
              }
            });
          }
        });
        break;

        case ROLES.SUPPORTTEAM:
          let labelsToRemoveForSupport = ['แจ้งเข้ารับกากของเสีย'];

          allMenus = allMenus.filter(menu => !labelsToRemoveForSupport.includes(menu.items[0].label));

          allMenus.forEach(menuSection => {
            if (menuSection.items.some(item => item.label === 'การจัดการข้อมูล')) {
              menuSection.items.forEach(item => {
                if (item.label === 'การจัดการข้อมูล') {
                  item.items = [
                    { label: 'ทะเบียนกากของเสีย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/wastemastermanage'] },
                  ];
                }
              });
            }

            if (menuSection.items.some(item => item.label === 'รายงาน')) {
              menuSection.items.forEach(item => {
                if (item.label === 'รายงาน') {
                  item.items = [
                    { label: 'Monthly report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/monthlyreport'] },
                    { label: 'GEI report', icon: 'pi pi-fw pi-circle', routerLink: ['/report/geireport'] },
                    { label: 'Waste transportation (CFO)', icon: 'pi pi-fw pi-circle', routerLink: ['/report/transportationreport'] },
                  ];
                }
              });
            }
          });
          break;

          case ROLES.OPERATOR:
            let labelsToRemoveForOper = ['รายงาน', 'แจ้งเข้ารับกากของเสีย'];

            allMenus = allMenus.filter(menu => !labelsToRemoveForOper.includes(menu.items[0].label));

            allMenus.forEach(menuSection => {
              if (menuSection.items.some(item => item.label === 'การจัดการข้อมูล')) {
                menuSection.items.forEach(item => {
                  if (item.label === 'การจัดการข้อมูล') {
                    item.items = [
                      { label: 'ทะเบียนกากของเสีย', icon: 'pi pi-fw pi-circle', routerLink: ['/admin/wastemastermanage'] },
                    ];
                  }
                });
              }
            });
            break;
    }

    this.model = allMenus;

  }

  initailizeIsAccept(){
    // if (localStorage.getItem('IsAccept') === 'N') {
    //   this.IsAccept = false;
    // } else {
    //   this.IsAccept = true;
    // }
    this.eventService.isAccept$.subscribe(value => {
      this.isAccept = value;
    });
  }

}
